// PAGETOPを押した時にゆっくりTOPへ移動
document.addEventListener('DOMContentLoaded', () => {
  const pageTopButton = document.querySelector('.gs_jump');

  if (!pageTopButton) return;

  pageTopButton.addEventListener('click', (e) => {
    e.preventDefault();

    const startPosition = window.scrollY;
    const duration = 1200; // 数字を大きくするとゆっくり
    const startTime = performance.now();

    const easeInOut = (t) => {
      return t < 0.5
        ? 2 * t * t
        : 1 - Math.pow(-2 * t + 2, 2) / 2;
    };

    const animation = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeInOut(progress);

      window.scrollTo(0, startPosition * (1 - easedProgress));

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  });
});